// extracted by mini-css-extract-plugin
export default {"body":"font-metrics-body-v4Onzo"};